import { INavItem } from '../interfaces/ICommon';
import { IColumnFilter } from '../interfaces/ITable';
import { FilterType } from './enums';

export const APP_URL = {
  DEED: '/deed',
  PROFILE: '/profile',
  COMPANY_INFO: 'company-info',
  LOGIN: '/login',
  ERROR_500: '/500',
  COMMON_CONTROL: '/common-control',
  ACTIVATE: '/activate',
  CREATE_DEED_FORM: 'deed/new-form',
  ADMIN: '/administration',
  ADMIN_DASHBOARD: '/administration/dashboard',
  ADMIN_LOGIN: '/admin',
  ADMIN_USER: '/administration/users',
  ADMIN_COMPANY: '/administration/company',
  ADMIN_CONTACT: '/administration/contacts',
  ADMIN_SUBSCRIPTION: '/administration/subscription',
  ADMIN_SUBSCRIPTIONS: '/administration/subscription/list',
  ADMIN_SUBSCRIPTION_PLAN: '/administration/subscription/plan',
  ADMIN_LOGS: '/administration/apiLog',
};

export const DROPDOWN_URL = {
  PROFILE: '/profile',
  COMPANY: '/company',
  COMPANY_INFO: 'company-info'
};

export const ROLES = {
  SYSTEM_ADMIN: 'System Admin',
  COMPANY_ADMIN: 'Company Admin',
  COMPANY_USER: 'Company User',
  USER: 'User'
}

export const PARAM_OPERATOR = {
  LIKE: 'like',
  EQUAL: 'equal',
  NOT_EQUAL: 'notequal',
  GREATER_THAN: 'greaterThan',
  LESS_THAN: 'lessThan',
  GREATER_THAN_OR_EQUAL: 'greaterThanOrEqual',
  LESS_THAN_OR_EQUAL: 'lessThanOrEqual'
};

export const STORAGE_KEY = {
  USER_LANGUAGE: 'userLanguage',
  APP_ID: 'appId',
  THEME: "theme"
};

export const DATE_PICKER_LOCALE = 'nb-NO';

export const DATE_FORMATS = {
  parse: {
    dateInput: 'DD.MM.YYYY'
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'DD.MM.YYYY',
    dateA11yLabel: 'DD.MM.YYYY',
    monthYearA11yLabel: 'DD.MM.YYYY'
  }
};

export const DEFAULT_LANGUAGE = 'no';

export const SITE_LANGUAGES = [
  {
    language: 'Norsk',
    code: 'no',
    icon: '/assets/images/svgs/flags/icon-flag-no.svg'
  },
  {
    language: 'English',
    code: 'en',
    type: 'US',
    icon: '/assets/images/svgs/flags/icon-flag-en.svg'
  }
];

export const COUNTRY_OPTIONS = [
  {
    name: 'USA',
    icon: '/assets/images/svgs/flags/united-states.svg'
  },
  {
    name: 'Netherlands',
    icon: '/assets/images/svgs/flags/netherlands.svg'
  },
  {
    name: 'UK',
    icon: '/assets/images/svgs/flags/icon-flag-en.svg'
  },
  {
    name: 'Norway',
    icon: '/assets/images/svgs/flags/icon-flag-no.svg'
  }
];

export const COLORS = {
  PRIMARY: '#2374c1',
  SECONDARY: '#6c757d',
  SUCCESS: '#28a745',
  DANGER: '#ff5454',
  WARNING: '#ffc107',
  INFO: '#17a2b8',
  LIGHT: '#f8f9fa',
  DARK: '#343a40',
  BORDER: '#0000001f',
  MAIN_THEME: '#5d87ff',
  GREEN_LOGO: '#6cbe00',
  WHITE: '#ffffff',
  TRANSPARENT: '#00000000',
  AVATAR_TEXT: '#7d3bcb',
  AVATAR_BG: '#e6d6fc',
  MUTED: '#6c757d'
};

export const EXPAND_ANIMATION = {
  NORMAL: 'expanded',
  NO_PADDING: 'expanded-no-padding'
};

export const FILE_TYPES = {
  basicImg: '.jpg, .png, .jpeg, .gif, .heic',
  img: 'jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff, .webp|image/*',
  docs: '.doc, .docx',
  excel: '.xls, .xlsx'
};

export const REGEX_PATTERNS = {
  EMAIL: '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$',
  PHONE: '^(\\+?[1-9]\\d{0,2})?\\s?\\(?\\d{1,4}\\)?\\s?\\d{1,4}[-\\s]?\\d{1,4}[-\\s]?\\d{1,9}$',
  DATE: /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{4})$/,
  TIME: /(2[0-3]|[01][0-9]):[0-5][0-9]/
};

export const TABLE_COLUMN_FILTER_LIST: IColumnFilter[] = [
  {
    name: 'Contains',
    paramOperator: PARAM_OPERATOR.LIKE,
    filterType: [FilterType.TEXT],
    icon: '/assets/images/svgs/operators/search-right.svg'
  },
  {
    name: 'Equals',
    paramOperator: PARAM_OPERATOR.EQUAL,
    filterType: [FilterType.TEXT, FilterType.DATE, FilterType.NUMBER],
    icon: '/assets/images/svgs/operators/equal.svg'
  },
  {
    name: 'No equal',
    paramOperator: PARAM_OPERATOR.NOT_EQUAL,
    filterType: [FilterType.DATE, FilterType.NUMBER],
    icon: '/assets/images/svgs/operators/equal-not.svg'
  },
  {
    name: 'Greater than',
    paramOperator: PARAM_OPERATOR.GREATER_THAN,
    filterType: [FilterType.DATE, FilterType.NUMBER],
    icon: '/assets/images/svgs/operators/greater-than.svg'
  },
  {
    name: 'Less than',
    paramOperator: PARAM_OPERATOR.LESS_THAN,
    filterType: [FilterType.DATE, FilterType.NUMBER],
    icon: '/assets/images/svgs/operators/less-than.svg'
  },
  {
    name: 'Greater than or equal',
    paramOperator: PARAM_OPERATOR.GREATER_THAN_OR_EQUAL,
    filterType: [FilterType.DATE, FilterType.NUMBER],
    icon: '/assets/images/svgs/operators/greater-than-or-equal.svg'
  },
  {
    name: 'Less than or equal',
    paramOperator: PARAM_OPERATOR.LESS_THAN_OR_EQUAL,
    filterType: [FilterType.DATE, FilterType.NUMBER],
    icon: '/assets/images/svgs/operators/less-than-or-equal.svg'
  }
];

export const DIALOG_WIDTH = {
  SMALLEST: '400px',
  SMALL: '500px',
  MEDIUM_SMALL: '600px',
  MEDIUM: '700px',
  LARGE: '900px',
  EXTRA_LARGE: '1100px'
};

export const COLOR = [
  "rgb(29, 178, 245)", "rgb(245, 86, 74)", "rgb(151, 201, 92)", "rgb(255, 199, 32)", "rgb(235, 53, 115)",
  "rgb(166, 61, 184)", "rgb(246, 112, 25)", "rgb(245, 55, 148)", "rgb(172, 194, 54)", "rgb(0, 169, 80)",
  "rgb(88, 89, 91)", "rgb(220, 53, 69)", "rgb(77, 182, 172)", "rgb(255, 213, 79)", "rgb(161, 136, 127)",
  "rgb(129, 199, 132)", "rgb(255, 87, 34)", "rgb(63, 81, 181)", "rgb(0, 150, 136)", "rgb(139, 195, 74)",
  "rgb(255, 235, 59)", "rgb(233, 30, 99)", "rgb(103, 58, 183)", "rgb(3, 169, 244)", "rgb(255, 152, 0)",
  "rgb(96, 125, 139)", "rgb(156, 39, 176)", "rgb(255, 64, 129)", "rgb(0, 188, 212)", "rgb(205, 220, 57)",
  "rgb(158, 158, 158)", "rgb(255, 193, 7)", "rgb(189, 189, 189)", "rgb(83, 109, 254)", "rgb(33, 150, 243)",
  "rgb(255, 99, 71)", "rgb(121, 85, 72)", "rgb(76, 175, 80)", "rgb(255, 138, 101)", "rgb(92, 107, 192)",
  "rgb(100, 181, 246)", "rgb(255, 171, 64)", "rgb(255, 20, 147)", "rgb(34, 193, 195)", "rgb(253, 187, 45)",
  "rgb(128, 222, 234)", "rgb(234, 130, 118)", "rgb(255, 61, 61)", "rgb(239, 83, 80)", "rgb(72, 201, 176)",
  "rgb(238, 174, 202)", "rgb(220, 144, 255)", "rgb(69, 90, 100)", "rgb(64, 196, 255)", "rgb(251, 140, 0)",
  "rgb(121, 85, 72)", "rgb(255, 193, 7)", "rgb(243, 229, 0)", "rgb(159, 152, 245)", "rgb(67, 160, 71)",
  "rgb(255, 82, 82)", "rgb(255, 183, 77)", "rgb(158, 238, 170)", "rgb(245, 124, 0)", "rgb(98, 0, 238)",
  "rgb(219, 40, 155)", "rgb(46, 125, 50)", "rgb(245, 0, 87)", "rgb(176, 190, 197)", "rgb(250, 140, 255)",
  "rgb(255, 248, 225)", "rgb(144, 202, 249)"
];

export const COMMON_EVENT = {
  BREADCRUMB: 'breadcrumb', // update breadcrumb
  RETURN_PROJECT_LIST: 'return-project-list',
  NOTIFICATION: 'notification',
  UPDATE_ROLE: 'updateRole',
  UPDATE_USER: 'updateUser'
}

export const TOKEN_TYPE = {
  ACCOUNT_ACTIVATION: "AccountActivation",
  PASSWORD_RESET: "PasswordReset"
}

export const FILTER_COLUMN_TYPE = {
  FILTER: "filter",
  RESET: "reset"
}

export const TABLE_STYLES = {
  STRIPED: "STRIPED",
  SOLID: "SOLID",
  EXPAND_CONTAINER: "EXPAND_CONTAINER",
  EXPAND_TREE: "EXPAND_TREE",
}

export const NAV_FORM_LISTING_ITEMS = [
  {
    id: 1,
    name: 'inbox',
    icon: 'mail',
    type: 'inbox'
  },
  {
    id: 2,
    name: 'archive',
    icon: 'archive',
    type: 'archive'
  },
  {
    id: 3,
    name: 'deleted',
    icon: 'trash',
    type: 'deleted'
  }
];

export const NAV_ITEM_SIDEBAR = [
  {
    displayName: 'new form',
    iconName: 'file-plus',
    route: 'deed//new-form',
    itemClass: "button-new-form"
  },
  {
    displayName: 'fill in progress',
    iconName: 'pencil',
    route: 'deed/fill-in-progress'
  },
  {
    displayName: 'ready to sign',
    iconName: 'writing',
    route: 'deed/ready-to-sign'
  },
  {
    displayName: 'sent for signature',
    iconName: 'mail',
    route: 'deed/sent-for-signature'
  },
  {
    displayName: 'ready to submitted',
    iconName: 'file-arrow-right',
    route: 'deed/ready-to-submitted'
  },
  {
    displayName: 'submitted',
    iconName: 'send',
    route: 'deed/submitted'
  },
  {
    displayName: 'archive',
    iconName: 'archive',
    route: 'deed/archive',
  },
  {
    displayName: 'deleted',
    iconName: 'trash',
    route: 'deed/deleted',
  }
]

export const NAV_ITEM_ADMIN_SIDEBAR = [
  {
    displayName: 'dashboard',
    iconName: "layout-dashboard",
    route: APP_URL.ADMIN_DASHBOARD
  },
  {
    displayName: 'company',
    iconName: "building-skyscraper",
    route: APP_URL.ADMIN_COMPANY
  },
  {
    displayName: 'user',
    iconName: "users",
    route: APP_URL.ADMIN_USER
  },
  {
    displayName: 'customer requests',
    iconName: "license",
    route: APP_URL.ADMIN_CONTACT
  },
   {
    displayName: 'api logs',
    iconName: "notebook",
    route: APP_URL.ADMIN_LOGS
  },
  {
    displayName: 'subscription',
    iconName: "brand-databricks",
    route: APP_URL.ADMIN_SUBSCRIPTION,
    children: [
      {
        displayName: 'subscription list',
        iconName: "list",
        route: APP_URL.ADMIN_SUBSCRIPTIONS
      },
      {
        displayName: 'subscription plan',
        iconName: "file-description",
        route: APP_URL.ADMIN_SUBSCRIPTION_PLAN
      }
    ]
  }
]

export const NAV_USER: INavItem[] = [
  {
    displayName: 'deed',
    iconName: 'layout-dashboard',
    route: APP_URL.DEED
  },
  {
    displayName: 'profile',
    iconName: 'layout-dashboard',
    route: APP_URL.PROFILE
  }
];

export const NAV_ADMIN: INavItem[] = [
  {
    displayName: 'company',
    iconName: 'settings',
    route: APP_URL.ADMIN_COMPANY,
    exact: true
  },
  {
    displayName: 'user',
    iconName: 'settings',
    route: APP_URL.ADMIN_USER,
    exact: true
  },
];

export const USER_ROLES = [
  { id: 2, roleName: 'Company Admin' },
  { id: 3, roleName: 'Company User' }
]

export const TYPE_OF_RESIDENCES = [
  {
    label: 'detached house',
    name: 'detached house',
    firstChar: "FB"
  },
  {
    label: 'two-family house',
    name: 'two-family house',
    firstChar: "TB"
  },
  {
    label: 'townhouse chain',
    name: 'townhouse chain',
    firstChar: "RK"
  },
  {
    label: 'apartment block',
    name: 'apartment block',
    firstChar: "BL"
  },
  {
    label: 'other',
    name: 'other',
    firstChar: "AN"
  }
]

export const USE_OF_LANDS = [
  {
    label: 'residential property',
    name: 'residential property',
    firstChar: "B"
  },
  {
    label: 'leisure property',
    name: 'leisure property',
    firstChar: "F"
  },
  {
    label: 'business/office',
    name: 'business/office',
    firstChar: "V"
  },
  {
    label: 'industry',
    name: 'industry',
    firstChar: "I"
  },
  {
    label: 'agriculture',
    name: 'agriculture',
    firstChar: "L"
  },
  {
    label: 'off-road',
    name: 'off-road',
    firstChar: "K"
  },
  {
    label: 'other',
    name: 'other',
    firstChar: "A"
  }
]

export const TRANSACTION_TYPES = [
  {
    label: 'free sale',
    name: 'free sale'
  },
  {
    label: 'gift (in whole or in part)',
    name: 'gift (in whole or in part)'
  },
  {
    label: "expropriation",
    name: "expropriation"
  },
  {
    label: 'foreclosure',
    name: 'foreclosure'
  },
  {
    label: 'unchanged',
    name: 'unchanged'
  },
  {
    label: 'probate settlement',
    name: 'probate settlement'
  }
]

export const CONTROL_PDF = {
  PREVIEW: "preview",
  DOWNLOAD: "download",
  FILE: "file"
}

export const LAYOUT_PDF = {
  hLineColor: () => '#bfbfbf',
  vLineColor: () => '#bfbfbf',
  hLineWidth: () => 0.2,
  vLineWidth: () => 0.2
}

export const TOKEN_VERIFIED_ERROR = {
  USER_NOT_FOUND: "User does not exist"
}

export const DEED_FORM = [
  { value: 1, label: 'filling in progress', path: "fill-in-progress" },
  { value: 2, label: 'ready to sign', path: "ready-to-sign" },
  { value: 3, label: 'sent for signature', path: "sent-for-signature" },
  { value: 4, label: 'ready to submitted', path: 'ready-to-submitted' },
  { value: 5, label: 'submitted', path: "submitted" },
  { value: 7, label: 'archive', path: "archive" },
  { value: 8, label: 'deleted', path: "deleted" }
]

export const SUBMITTED_TIMELINE = [
  { value: 1, label: 'ready' },
  { value: 2, label: 'submitted' },
  { value: 3, label: 'accepted' },
  { value: 4, label: 'rejected' }
]

export const SUBSCRIPTION_DURATION = {
  Monthly: 1,
  Quarterly: 3,
  Yearly: 12
};

export const PERMISSIONS = {
  MAX_FORMS: "maxForms",
  MAX_USERS: "maxUsers",
  CAN_VIEW_ESTATE: "canViewEstate",
  CAN_SEND_SIGNATURE: "canSendSignature"
}

export const BUSINESS_LAND_USE = [
  'business/office',
  'industry',
  'agriculture',
  'off-road',
  'other'
]

export const KARTVERKET_STATUS_MAP: Record<string, string> = {
  MOTTATT: 'received',
  UNDER_BEHANDLING: 'processing',
  AVSLUTTET: 'completed',
  SENDT_TIL_ALTINN: 'sent to altinn'
};

export const MONTH_OPTIONS = [
  { name: 'all', value: 0 },
  { name: 'january', value: 1 },
  { name: 'february', value: 2 },
  { name: 'march', value: 3 },
  { name: 'april', value: 4 },
  { name: 'may', value: 5 },
  { name: 'june', value: 6 },
  { name: 'july', value: 7 },
  { name: 'august', value: 8 },
  { name: 'september', value: 9 },
  { name: 'october', value: 10 },
  { name: 'november', value: 11 },
  { name: 'december', value: 12 }
];